/** Entry point — mounts the shell and registers the service worker (prod). */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app.js";
import "./design/humble.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root missing from index.html");

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// PWA: offline static shell (PRD §10). The sw is emitted at build with the
// hashed precache list (vite.config.ts) — dev runs without it.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* offline shell is an enhancement, never a blocker */
    });
  });
}
